import script from "./ChatInterface.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatInterface.vue?vue&type=script&setup=true&lang=js"

import "./ChatInterface.vue?vue&type=style&index=0&id=13386f96&lang=scss"

const __exports__ = script;

export default __exports__